export const MAX_LENGTH = 20;
export const MAX_HEIGHT = 3.1;
export const MAX_WIDTH = 2.55;
